export const convertToKilobyte = (size) => {
  const sizeInKB = size / 1024;

  return `${sizeInKB.toFixed(2)} kb`;
};
